import React, { useState, useEffect } from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import apiClient from "../../utils/apiClient";
import { imageBaseurl } from "../../utils/common";

const pageLengthArray = [10, 20, 30, 50, 70, 100, 500];

const JobList = () => {
  const [JobList, setJobList] = useState([]);
  const [page, setPage] = useState(1);
  const [pageLength, setPageLength] = useState(10);
  const [PostType, setPostType] = useState("blog");
  const navigate = useNavigate();
  const [status, setStatus] = useState("1");
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    if(PostType && status){
      getAllJobs();
    }
  }, [page, pageLength, PostType, status]);

  const getAllJobs = async () => {
    try {
      const response = await apiClient.get(`/api/blog?page=${page}&type=${PostType}&limit=${pageLength}&status=${status}`);
      setJobList(response.data.data.data || []);
      setTotalPages(response.data.data.totalPages);
      setTotalCount(response.data.data.totalCount);
      console.log(response.data.data,'ooo')
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };

  const routeChange = (path) => {
    navigate(path);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <div className="container my-5">
      <div className="card shadow-lg">
        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <h3 className="mb-0">Posts List</h3>
          <span>
          Total Post : {totalCount}
          <br />
          Total Page : {totalPages}
          </span>
          <button
            className="btn btn-success"
            onClick={() => routeChange('/blog/add')}
          >
            Add New Post
          </button>
        </div>
        <div className="card-body">
          <div className="row mb-4">
            <div className="col-md-3">
              <select
                className="form-control form-control-lg"
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                  setPage(1);
                }}
              >
                <option value="">Select Status</option>
                <option value="0">Inactive</option>
                <option value="1">Active</option>
              </select>
            </div>
            <div className="col-md-3">
              <select
                className="form-control form-control-lg"
                value={pageLength}
                onChange={(e) => {
                  setPage(1);
                  setPageLength(Number(e.target.value));
                }}
              >
                {pageLengthArray.map((res) => (
                  <option key={res} value={res}>{res}</option>
                ))}
              </select>
            </div>
          </div>

          {JobList?.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-muted2">No posts found.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover table-bordered">
                <thead className="table-primary">
                  <tr>
                    <th className="text-center">#</th>
                    <th>Title</th>
                    <th>Image</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {JobList.map((res, index) => (
                    <tr key={res.postId} className="align-middle">
                      <td className="text-center">{(page - 1) * pageLength + index + 1}</td>
                      <td>{res.title}</td>
                      <td>
                        <img
                          src={imageBaseurl + res.image || ""}
                          alt={res.title}
                          className="img-thumbnail"
                          style={{ width: 50, height: 50, objectFit: "cover" }}
                          onError={(e) => {
                            e.target.src = "";
                          }}
                        />
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            res.active == "1" ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {res.active == "1" ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => routeChange(`/blog/edit/${res.postId}`)}
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination */}
          <nav aria-label="Page navigation">
           
            <ul className="pagination justify-content-center mt-4">
              <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 1}
                >
                  Previous
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                <li
                  key={p}
                  className={`page-item ${page === p ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(p)}
                    style={{ cursor: "pointer" }}
                  >
                    {p}
                  </button>
                </li>
              ))}
              <li className={`page-item ${page >= totalPages ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page === totalPages}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default JobList;